import { ExtendedRoutes } from '@increff/commons';

export const ADMIN_ROUTES: ExtendedRoutes = [
    {
        name: 'Admin',
        baseUrl: '/admin',
        path: 'admin',
        iconClass: 'shield-account',
        children: [
            {
                name: 'Applications',
                baseUrl: '/applications',
                path: 'applications',
                iconClass: 'account-shield'
            },
            {
                name: 'Organisations',
                baseUrl: '/organisations',
                path: 'organisations',
                iconClass: 'view-list'
            },
            {
                name: 'Users',
                baseUrl: '/users',
                path: 'users',
                iconClass: 'account-multiple',
                data: {
                    flow: 'admin'
                }
            },
            {
                name: 'IP Management',
                baseUrl: '/ip-management',
                path: 'ip-management',
                iconClass: 'cog'
            },
            {
                name: 'Audit Log',
                baseUrl: '/audit-log',
                path: 'audit-log',
                iconClass: 'history'
            },
        ]
    },
];

export const DOMAIN_ROUTES: ExtendedRoutes = [
    {
        name: 'Domain',
        baseUrl: '/domain',
        path: 'domain',
        iconClass: 'shield-account',
        children: [
            {
                name: 'Users',
                baseUrl: '/users',
                path: 'users',
                iconClass: 'account-multiple',
                data: {
                    flow: 'domain'
                }
            },
            {
                name: 'Profile',
                baseUrl: '/profile',
                path: 'profile',
                iconClass: 'account-edit',
                hideRoute: true

            },
            {
                name: 'Audit Log',
                baseUrl: '/audit-log',
                path: 'audit-log',
                iconClass: 'history'
            },
        ]
    },
];

export const APP_ROUTES: ExtendedRoutes = [
    {
        path: '',
        baseUrl: '',
        title: 'Landing',
        iconClass: 'account-shield',
        name: 'Landing',
        hideRoute: true
    },
    ...DOMAIN_ROUTES,
    ...ADMIN_ROUTES
];
